import React, { Component } from "react";
import ScanBarcodeContextProvider from "./context/ScanBarcodeContext";
import ScanBarcodeView from "./views/ScanBarcodeView";

class ScanBarcode extends Component {
  render() {
    return (
      <ScanBarcodeContextProvider>
        <ScanBarcodeView
          image={this.props.image}
          onScanResponse={this.props.onScanResponse}
        />
      </ScanBarcodeContextProvider>
    );
  }
}

export default ScanBarcode;



// WEBPACK FOOTER //
// ./src/components/scanBarcode/scanBarcode.js